import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取当前登录用户商户 ID
function getCurrentStoreId() {
  try {
    const user = JSON.parse(localStorage.getItem('userInfo') || '{}')
    return user.storeId || ''
  } catch (e) {
    return ''
  }
}

// 查询考勤审核人员列表
export function listAttendanceAuditStaffs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attendanceAuditStaff.listAttendanceAuditStaffs',
      method: 'post',
      data: {
        page: -1,
        row: 100,
        ...params,
        storeId: getCurrentStoreId() || params.storeId,
        communityId: getCommunityId() || params.communityId
      }
    }).then(response => {
      const res = response.data
      // 后端格式：ResultVo.createResponseEntity(code, msg, new Object[]{list, total})
      // 即 res.data = [list, total]，所以 res.data[0] 是记录数组，res.data[1] 是 total
      const rawData = res.data || []
      const listData = Array.isArray(rawData[0])
        ? rawData[0]
        : (Array.isArray(rawData) ? rawData : [])
      const totalCount = typeof rawData[1] === 'number'
        ? rawData[1]
        : (res.records || res.total || 0)
      resolve({
        data: listData,
        total: totalCount
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存考勤审核人员
export function saveAttendanceAuditStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attendanceAuditStaff.saveAttendanceAuditStaff',
      method: 'post',
      data: {
        ...data,
        storeId: getCurrentStoreId() || data.storeId,
        communityId: getCommunityId() || data.communityId
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除考勤审核人员
export function deleteAttendanceAuditStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attendanceAuditStaff.deleteAttendanceAuditStaff',
      method: 'post',
      data: {
        ...data,
        storeId: getCurrentStoreId() || data.storeId
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
